import * as React from 'react';
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Select from '@mui/material/Select';

import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import useMediaQuery from '@mui/material/useMediaQuery';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';

import CheckIcon from '@mui/icons-material/Check';

import { Swiper } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import "./../assets/swiperCss.css";
import 'swiper/css/autoplay';

import PropTypes, { number } from 'prop-types';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import AssignmentReturnTwoToneIcon from '@mui/icons-material/AssignmentReturnTwoTone';
import InventoryTwoToneIcon from '@mui/icons-material/InventoryTwoTone';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import AddPhotoAlternateTwoToneIcon from '@mui/icons-material/AddPhotoAlternateTwoTone';
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfTwoTone';

import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';

import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import { themeResponsive } from "../../theme/responsiveTheme.js";

import AdminMenuComponent from "../../components/admin/AdminMenuComponent.js";
import CreateNewFolderTwoToneIcon from '@mui/icons-material/CreateNewFolderTwoTone';
import SaveAltSharpIcon from '@mui/icons-material/SaveAltSharp';

// ---- Calendar
import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import 'dayjs/locale/it';
import { TimeClock } from '@mui/x-date-pickers/TimeClock';

import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { itIT } from '@mui/x-date-pickers/locales';

import { getGiornoDellAnno, getNumberOfDays, getIndexOfDaysDb, dayOfYear, getNumberOfWeek, getHoursAndMinutesStringFromMinutes } from '../../utils/dayUtils.js'
import { durationsMins } from './../../constants/durationsMins.ts';

import AppointmentCardComponent from "./AppointmentCardComponent.js";

import CreateAppointmentElementCard from "./../admin/components/CreateAppointmentElementCard.js";

const { strDateITAfromDayJs, strDateUSAfromDayJs, strDateITAfromStrUSA, strDateUSAfromStrITA } = require('../../utils/dateUtils.js')

const config = require("../../constants/constants.js")

const responsiveTheme = responsiveFontSizes(themeResponsive);

const widthPageSlide = 600;

const AppointmentPageComponent = ({ loginUserApiRequest, reduxDispatch, setReduxUserState }) => {
  const [validated, setValidated] = useState(false);
  const [loginUserResponseState, setLoginUserResponseState] = useState({
    success: "",
    error: "",
    loading: false,
  });

  const navigate = useNavigate();

  const config = require("../../constants/constants.js")

  const [name, setName] = useState("");
  const [note, setNote] = useState("");
  const [color, setColor] = useState("0000");
  const [count, setCount] = useState(0);
  const [price, setPrice] = useState(0);
  const [isBookable, setIsBookable] = useState(false);
  const [bookingPrice, setBookingPrice] = useState(0);
  const [category, setCategory] = useState("");
  const [event, setEvent] = useState("");
  const [images, setImages] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [linkHttp, setLinkHttp] = useState("");

  const [eventTypesList, setEventTypesList] = useState([]);
  const [eventsList, setEventsList] = useState([]);

  const [isManyDays, setIsManyDays] = useState(false);

  const [displayPaperImages, setDisplayPaperImages] = useState("");

  const [bookingStartDate, setBookingStartDate] = React.useState(dayjs(new Date()));
  const [bookingStartDateNameOfWeek, setBookingStartDateNameOfWeek] = React.useState(dayjs(new Date()).format('dddd'));
  const [bookingEndDate, setBookingEndDate] = React.useState(dayjs(new Date()));
  const [bookingEndDateNameOfWeek, setBookingEndDateNameOfWeek] = React.useState(dayjs(new Date()).format('dddd'));

  const [hourStartBooking, setHourStartBooking] = React.useState(dayjs());
  const [hourStartBookingString, setHourStartBookingString] = useState("");
  const [indexStartDateBooking, setIndexStartDateBooking] = useState(0);
  const [hourEndBooking, setHourEndBooking] = React.useState(dayjs());
  const [hourEndBookingString, setHourEndBookingString] = useState("");
  const [indexEndDateBooking, setIndexEndDateBooking] = useState(0);

  const [categoriaScelta, setCategoriaScelta] = useState("");  // è la categoria cliccata nelTab "scegli la categoria"
  const [prodottoScelto, setProdottoScelto] = useState("");     // è il servizio/prodotto cliccata nelTab "scegli il servizio"

  const [titleAppointment, setTitleAppointment] = useState("");
  const [descriptionAppointment, setDescriptionAppointment] = useState("");
  const [noteAppointment, setNoteAppointment] = useState("");
  const [clienteDigitato, setClienteDigitato] = useState("");                     // è la ora cliccata nelTab
  const [risorsaScelta, setRisorsaScelta] = useState("");        // è la ora risorsa cliccata nelTab "scegli la risorsa"
  const [sitoScelto, setSitoScelto] = useState("");                 // è il sito cliccato nelTab "scegli il sito"
  const [clienteScelto, setClienteScelto] = useState("");           // è il cliente cliccato nelTab "scegli il cliente"
  const [durataScelta, setDurataScelta] = useState("0");                            // è la durata cliccata nelTab
  const [resources, setResources] = useState([]);
  const [sites, setSites] = useState([]);
  const [customersList, setCustomersList] = useState([]);

  const [sito, setSsito] = useState("");
  const [cliente, setCliente] = useState("");
  const [risorsa, setRisorsa] = useState("");

  const [page, setPage] = useState({});
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [description, setDescription] = useState("");
  const [customizedName, setCustomizedName] = useState("");
  const [customizedStreet, setCustomizedStreet] = useState("");
  const [customizedZip, setCustomizedZip] = useState("");
  const [customizedCity, setCustomizedCity] = useState("");
  const [customizedEmail, setCustomizedEmail] = useState("");
  const [customizedTelephone, setCustomizedTelephone] = useState("");
  const [tabAttivo, setTabAttivo] = React.useState('home');
  const [pathImage0, setPathImage0] = useState("");
  const [titleImage0, setTitleImage0] = useState("");
  const [subTitleImage0, setSubTitleImage0] = useState("");

  const address_marginLeft = "30px";

  const [showDateSection, setShowDateSection] = useState("");
  const [showHourAppointmentSection, setShowHourAppointmentSection] = useState("");
  const [showDailyEventsSection, setShowDailyEventsSection] = useState("");

  const [showInfoEventSection, setShowInfoEventSection] = useState("");
  const [showDisplayEventSection, setShowDisplayEventSection] = useState("");
  const [showDeleteEventSection, setShowDeleteEventSection] = useState("");

  const [showDetailAppointmentNumber, setShowDetailAppointmentNumber] = useState(-1);

  const [appointment, setAppointment] = useState({});
  const [appointments, setAppointments] = useState([{}]);
  const [dailyAppointments, setDailyAppointments] = useState([{}]);

  const [imageRemoved, setImageRemoved] = useState(false)
  const [isUploading, setIsUploading] = useState("");
  const [imageUploaded, setImageUploaded] = useState(false);
  const [idStoreImages, setIdStoreImages] = useState("");
  const [pageImageItems, setPageImageItems] = useState([]);

  const uploadAppointmentImagesApiRequest = async (images, indexDay, indexAppointment) => {

    console.log("[uploadAppointmentImagesApiRequest]")
    console.log("[uploadAppointmentImagesApiRequest] images=", images)
    console.log("[uploadAppointmentImagesApiRequest] indexDay=", indexDay)
    console.log("[uploadAppointmentImagesApiRequest] indexAppointment=", indexAppointment)

    const formData = new FormData();
    Array.from(images).forEach((image) => {
      formData.append("images", image);
    });

    console.log("[uploadAppointmentImagesApiRequest] formData=", formData)
    console.log("[uploadAppointmentImagesApiRequest] POST /api/appointments/admin/upload?eventId")

    const { data } = await axios.post("/api/appointments/admin/upload?indexDay=" + indexDay + "&indexAppointment=" + indexAppointment, formData);
    return data;
  };

  const handleLoadImage = (event) => {
    const files = Array.from(event.target.files);
    const statusStep = 100 / files.length;

    console.log("[handleLoadImage] event.target.files=" + event.target.files)
    console.log("[handleLoadImage] files.length=" + files.length)

    for (let i = 0; i < files.length; i++) {
      // ## controllo dimensione totale
      //
      // uploadItem(files[i]);
      // Here it guarantees that state updated correctly
      // setState(prevStep => prevStep + statusStep);
    }

    setIsUploading("upload files in corso ...");
    uploadAppointmentImagesApiRequest(event.target.files, indexStartDateBooking, showDetailAppointmentNumber)
      .then(data => {
        //if (data.message === "event updated") navigate("/admin/events");
        setIsUploading("upload files completato");
        setImageUploaded(!imageUploaded);
      })
      .catch((er) => setIsUploading(er.response.data.message ? er.response.data.message : er.response.data));
    window.location.assign(`/agenda`)
  };


  const getPageByMenuValueApiRequest = async (menuValue) => {
    console.log("[getPageByMenuValueApiRequest] leggo page con menuValue =", menuValue);
    const url = `/api/pages/menuValue/` + menuValue;
    const { data } = await axios.get(url);
    //console.log(`data =`, data);
    return data
  }

  useEffect(() => {
    getPageByMenuValueApiRequest('AGENDA').then((data) => {
      //console.log(`data 1 =`, data);
      setPage(data);
      setTitle(data?.title.text);
      setSubTitle(data?.subTitle.text);
      setDescription(data?.description.text);
      setTabAttivo('home');
      setId(data?._id);
      setCustomizedName(page?.customizedContent.name.text);
      setCustomizedStreet(page?.customizedContent.street.text);
      setCustomizedZip(page?.customizedContent.zip.text);
      setCustomizedCity(page?.customizedContent.city.text);
      setCustomizedEmail(page?.customizedContent.email.text);
      setCustomizedTelephone(page?.customizedContent.telephone.text);
      setPathImage0(data?.images[0].path);
      setTitleImage0(data?.imagesTitle[0].text);
      setSubTitleImage0(data?.imagesSubTitle[0].text);

      //setShowDailyEventsSection("Si");
      handleVediEventiGiorno();
      //console.log(`id =`, id);
      //console.log(`page?.images =`, page?.images);
      //console.log(`page?.title.text =`, page?.title.text);
      //console.log(`page?.description.text =`, page?.description.text);
      //console.log(`page?.customizedContent =`, page?.customizedContent);
      //console.log(`page?.customizedContent.name.text =`, page?.customizedContent.zip.text);
      //console.log(`images =`, data?.images);
      //console.log(`images =`, data?.images[0].path);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [tabAttivo, id])


  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const [loginIcon, setLoginIcon] = React.useState(false);

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const selectionEndDateFromCalendar = (event) => {
    console.log("date selected =" + event.format('YYYY-MM-DD'));
    console.log("name of day =" + event.format('dddd'));
    setBookingEndDate(dayjs(event.format('YYYY-MM-DD')));
    setBookingEndDateNameOfWeek(config.DAY_ITALIAN_NAMES[dayjs(event).day()]);
    //setIndexEndDateBooking(getIndexOfDaysDb(new Date(event.format('MM/DD/YYYY')), correctionIndexDay));
    //console.log("indexDate per DB = ", getIndexOfDaysDb(new Date(event.format('MM/DD/YYYY')), correctionIndexDay));
  }

  const handleSelectionStartHourFromCalendar = (event) => {
    console.log("[handleSelectionStartHourFromCalendar] event =" + event);
    console.log("[handleSelectionStartHourFromCalendar] event hh =" + event.format('HH:mm'));
    setHourStartBooking(event);
    setHourStartBookingString(event.format('HH:mm'));
  }

  const handleSelectionEndHourFromCalendar = (event) => {
    console.log("[handleSelectionEndHourFromCalendar] event =" + event);
    console.log("[handleSelectionEndHourFromCalendar] event hh =" + event.format('HH:mm'));
    setHourEndBooking(event);
    setHourEndBookingString(event.format('HH:mm'));
  }

  const handleChangeDurata = (event) => {
    setDurataScelta(event.target.value);
    console.log('[handleChangeDurata} event.target.value=', event.target.value);

    let hourInMinutesStart = Number(hourStartBookingString.substring(0, 2)) * 60 + Number(hourStartBookingString.substring(3, 5));
    console.log("hourInMinutesStart=", hourInMinutesStart);
    console.log("getHoursAndMinutesStringFromMinutes=", getHoursAndMinutesStringFromMinutes(hourInMinutesStart));
    let startHourString = getHoursAndMinutesStringFromMinutes(hourInMinutesStart);
    console.log("startHourString=>", startHourString.hourMinutesString);

    console.log("[handleChangeDurata] durataScelta=", event.target.value);

    // endDateDaily da calcolare
    //setHourEndBookingString(hourStartBookingString);

    let hourInMinutesEnd = Number(hourStartBookingString.substring(0, 2)) * 60 + Number(hourStartBookingString.substring(3, 5)) + event.target.value;
    console.log("hourInMinutesEnd=", hourInMinutesEnd);
    console.log("getHoursAndMinutesStringFromMinutes=", getHoursAndMinutesStringFromMinutes(hourInMinutesEnd));
    let endHourString = getHoursAndMinutesStringFromMinutes(hourInMinutesEnd);
    console.log("endHourString=>", endHourString.hourMinutesString);    // è giusta

    setHourEndBookingString(endHourString.hourMinutesString);
    console.log("hourEndBookingString=>", endHourString.hourMinutesString);
    setHourEndBooking(endHourString.hourMinutesString);

  }


  const handleVediEventiGiorno = (e) => {

    //setIndexStartDateBooking(getIndexOfDaysDb(dayjs(event.format('YYYY-MM-DD')))); 

    console.log("[handleVediEventiGiorno] bookingStartDate =" + bookingStartDate.format('YYYY-MM-DD'));
    setIndexEndDateBooking(getIndexOfDaysDb(dayjs(bookingStartDate.format('YYYY-MM-DD'))));

    console.log("[handleVediEventiGiorno] vedi eventi di indexStartDateBooking=", indexStartDateBooking);

    setAppointments(null);
    setDailyAppointments(null);

    // leggo db

    getAppointmentsByDayApiRequest(indexStartDateBooking)
      .then((data) => {
        setAppointments(data?.appointments);
        setDailyAppointments(data[0]?.appointments);
        //setAppointments(data?.appointments);
        console.log('[handleVediEventiGiorno] data=', data);
        console.log('[handleVediEventiGiorno] data?.appointments=', data[0]?.appointments);
        //console.log('appointment=', data?.appointment);
        //console.log('appointments=', data?.appointments);
        //setAppointment(data?.appointments[0]);
        //console.log('appointment=', data?.appointment);

      })
      .catch((er) => {
        console.log(er);
      });

    setShowDailyEventsSection("Si");
  };

  const handleAnnullaFissaOraAppuntamento = (event) => {
    setShowHourAppointmentSection("No");
  }

  const handleAnnullaEventiDelGiorno = (event) => {
    setShowDailyEventsSection("No");
    setShowInfoEventSection("No");

    setShowDisplayEventSection("No");
    setShowDeleteEventSection("No");
  }

  const handleAnnullaInserisciInfo = (event) => {
    setShowInfoEventSection("No");

    setShowDisplayEventSection("No");
    setShowDeleteEventSection("No");

    setShowDailyEventsSection("Si");
  }

  const handleAnnullaInCreaAppuntamento = (event) => {
    setShowDetailAppointmentNumber(-1);

    setShowDailyEventsSection("Si");
  }

  const handleConfermaOraAppuntamento = (event) => {
    setShowInfoEventSection("Si");
  }

  const createAppointmentApiRequest = async (formInputs) => {
    //console.log("[createAppointmentApiRequest]");
    //console.log("[createAppointmentApiRequest] formInputs=", formInputs);
    const { data } = await axios.post(`/api/appointments`, { ...formInputs });
    return data;
  };

  const getAppointmentsByDayApiRequest = async (indexDay) => {
    //console.log("[getAppointmentsByDayApiRequest]");
    //console.log("[getAppointmentsByDayApiRequest] indexDay=", indexDay);
    const { data } = await axios.get(`/api/appointments/indexDay/${indexDay}`);
    return data;
  };

  const updateAppointmentApiRequest = async (indexDay, indexAppointment) => {

    console.log("[updateAppointmentApiRequest] indexDay=", indexDay)
    console.log("[updateAppointmentApiRequest] indexAppointment=", indexAppointment)

    let infoAppointment = {}
    let startDate = {}
    let endDate = {}

    //console.log(">>" + hourStartBookingString.substring(0, 2));
    //console.log(">>" + hourStartBookingString.substring(3, 5));

    let hourInMinutesStart = Number(hourStartBookingString.substring(0, 2)) * 60 + Number(hourStartBookingString.substring(3, 5));
    //console.log("hourInMinutesStart=", hourInMinutesStart);
    //console.log("getHoursAndMinutesStringFromMinutes=", getHoursAndMinutesStringFromMinutes(hourInMinutesStart));
    let startHourString = getHoursAndMinutesStringFromMinutes(hourInMinutesStart);
    //console.log("startHourString=>", startHourString.hourMinutesString);

    /*
        console.log("[updateAppointmentApiRequest] durataScelta=", durataScelta);
        if (durataScelta === "0") {
          console.log("[updateAppointmentApiRequest] devi indicare una durata");
          //Alert("devi indicare una durata");
          alert("devi indicare una durata");
        } else {
        }
    */
    startDate = {
      hour: hourInMinutesStart,
      hourString: startHourString.hourMinutesString,
      indexDay: indexStartDateBooking,
      stringDay: strDateITAfromStrUSA(dayjs(bookingStartDate)),
      dayOfYear: getGiornoDellAnno(new Date(bookingStartDate)),
      weekOfYear: getNumberOfWeek(new Date(bookingStartDate)),
    }

    console.log("hourEndBookingString = ", hourEndBookingString);

    let hourInMinutesEnd = Number(hourEndBookingString.substring(0, 2)) * 60 + Number(hourEndBookingString.substring(3, 5));
    console.log("hourInMinutesEnd=", hourInMinutesEnd);
    console.log("getHoursAndMinutesStringFromMinutes=", getHoursAndMinutesStringFromMinutes(hourInMinutesEnd));
    let endHourString = getHoursAndMinutesStringFromMinutes(hourInMinutesEnd);
    console.log("startHourString=>", endHourString.hourMinutesString);

    endDate = {
      hour: hourInMinutesEnd,
      hourString: endHourString.hourMinutesString,
      indexDay: indexEndDateBooking,
      stringDay: strDateITAfromStrUSA(dayjs(bookingEndDate)),
      dayOfYear: getGiornoDellAnno(new Date(bookingEndDate)),
      weekOfYear: getNumberOfWeek(new Date(bookingEndDate)),
    }

    infoAppointment = {
      "indexDay": indexDay,
      "indexAppointment": indexAppointment,
      "name": titleAppointment,
      "description": descriptionAppointment,
      "note": noteAppointment,
      "event": prodottoScelto,
      "eventtype": categoriaScelta,
      "start": startDate,
      "end": endDate,
      "durationMins": durataScelta,
      "resource": risorsaScelta,
      "site": sitoScelto,
      "customer": clienteDigitato,
    }

    console.log("[updateAppointmentApiRequest] infoAppointment=", infoAppointment)
    console.log("[updateAppointmentApiRequest] POST /api/appointments/update?indexDay")

    const { data } = await axios.post("/api/appointments/update", infoAppointment);
    return data;
  };

  const handleSalvaAppuntamento = (event) => {

    console.log("[handleSalvaAppuntamento] salva appuntamenti di indexStartDateBooking=", indexStartDateBooking);
    console.log("[handleSalvaAppuntamento] bookingStartDate =" + bookingStartDate.format('YYYY-MM-DD'));

    //event.preventDefault();
    //event.stopPropagation();

    let infoAppointment = {}
    let startDate = {}
    let endDate = {}

    //console.log(">>" + hourStartBookingString.substring(0, 2));
    //console.log(">>" + hourStartBookingString.substring(3, 5));

    let hourInMinutesStart = Number(hourStartBookingString.substring(0, 2)) * 60 + Number(hourStartBookingString.substring(3, 5));
    console.log("START hourInMinutesStart=", hourInMinutesStart);
    //console.log("getHoursAndMinutesStringFromMinutes=", getHoursAndMinutesStringFromMinutes(hourInMinutesStart));
    let startHourString = getHoursAndMinutesStringFromMinutes(hourInMinutesStart);
    console.log("START startHourString=>", startHourString.hourMinutesString);

    console.log("[handleSalvaAppuntamento] durataScelta=", durataScelta);

    {/* 
    if (durataScelta === "0") {
      console.log("[handleSalvaAppuntamento] devi indicare una durata");
      //Alert("devi indicare una durata");
      alert("devi indicare una durata");
    } else {
    }
  */}

    startDate = {
      hour: hourInMinutesStart,
      hourString: startHourString.hourMinutesString,
      indexDay: indexStartDateBooking,
      stringDay: strDateITAfromStrUSA(dayjs(bookingStartDate)),
      dayOfYear: getGiornoDellAnno(new Date(bookingStartDate)),
      weekOfYear: getNumberOfWeek(new Date(bookingStartDate)),
    }

    setIndexEndDateBooking(indexStartDateBooking);

    let hourInMinutesEnd = Number(hourEndBookingString.substring(0, 2)) * 60 + Number(hourEndBookingString.substring(3, 5)) + durataScelta;
    console.log("STOP hourInMinutesEnd=", hourInMinutesEnd);
    //console.log("getHoursAndMinutesStringFromMinutes=", getHoursAndMinutesStringFromMinutes(hourInMinutesEnd));
    let endHourString = getHoursAndMinutesStringFromMinutes(hourInMinutesEnd);
    console.log("STOP endHourString=>", endHourString.hourMinutesString);

    endDate = {
      hour: hourInMinutesEnd,
      hourString: endHourString.hourMinutesString,
      indexDay: indexEndDateBooking,
      stringDay: strDateITAfromStrUSA(dayjs(bookingEndDate)),
      dayOfYear: getGiornoDellAnno(new Date(bookingEndDate)),
      weekOfYear: getNumberOfWeek(new Date(bookingEndDate)),
    }

    infoAppointment =
    {
      "name": titleAppointment,
      "description": descriptionAppointment,
      "note": noteAppointment,
      "event": prodottoScelto,
      "eventtype": categoriaScelta,
      "resource": risorsaScelta,
      "site": sitoScelto,
      "durationMins": durataScelta,
      "customer": clienteDigitato,
      "start": startDate,
      "end": endDate,
    };

    const formInputs = {
      indexDay: indexStartDateBooking,
      stringDay: strDateITAfromStrUSA(dayjs(bookingStartDate)),
      dayOfYear: getGiornoDellAnno(new Date(bookingStartDate)),
      weekOfYear: getNumberOfWeek(new Date(bookingStartDate)),
      numAppointments: 1,
      appointments: infoAppointment,
    };

    console.log('[handleSalva] showDetailAppointmentNumber=', showDetailAppointmentNumber)
    console.log('[handleSalva] formInputs=', formInputs)

    if (showDetailAppointmentNumber === -1) {
      createAppointmentApiRequest(formInputs)
        .then((data) => {

        })
        .catch((er) => {
          console.log(er);
        });

      //alert("Appuntamento salvato showDetailAppointmentNumber = " + showDetailAppointmentNumber);

      setShowInfoEventSection("No");
      setShowHourAppointmentSection("No");
      console.log("[handleSalvaAppuntamento] showHourAppointmentSection=", showHourAppointmentSection)

    } else {

      updateAppointmentApiRequest(indexStartDateBooking, showDetailAppointmentNumber)
        .then((data) => {

        })
        .catch((er) => {
          console.log(er);
        });

      //alert("Appuntamento modificato showDetailAppointmentNumber = " + showDetailAppointmentNumber);
      setShowInfoEventSection("No");
      setShowHourAppointmentSection("No");
      console.log("[handleSalvaAppuntamento] showHourAppointmentSection=", showHourAppointmentSection)

      // render page
      //navigate(0);                            

    }

    //setShowHourAppointmentSection("No");
    //setShowDetailAppointmentNumber(-1);
    //setShowInfoEventSection("No");
    //setShowHourAppointmentSection("No");
    //console.log("[handleSalvaAppuntamento] showHourAppointmentSection=", showHourAppointmentSection)

    // render page
    navigate(0);

  };

  const getEventsApiRequest = async (categoryName, pageNumParam = null, searchQuery = "", filters = {}, sortOption = "") => {
    console.log('categoryName=', categoryName)
    //console.log('categoriaScelta=',category)  
    const search = searchQuery ? `search/${searchQuery}/` : "";
    const category = categoryName ? `category/${categoryName}/` : "";
    const url = `/api/events/event/${categoryName}`;
    const { data } = await axios.get(url);
    return data
  }

  const handleSelectEventType = (event) => {
    setCategory(event.target.value);
    setCategoriaScelta(event.target.value);

    getEventsApiRequest(event.target.value, "", "", "", "")
      .then((productItems) => {
        setEventsList(productItems.events);
        console.log('combo =', event.target.value);
        //console.log('categoriaScelta=',categoriaScelta); 
        console.log('productItems=', productItems);
      })
      .catch((er) => {
        console.log(er);
      });
  };

  const handleSelectEvent = (event) => {
    setEvent(event.target.value);
    setProdottoScelto(event.target.value);
  };

  const getCategories = async (abctrl) => {
    const { data } = await axios.get("/api/eventtypes", {
      signal: abctrl.signal,
    });
    return data
  }

  const getResourcesApiRequest = async () => {
    const url = `/api/resources`;
    const { data } = await axios.get(url);
    return data
  }

  const getSitesApiRequest = async () => {
    const url = `/api/sites`;
    const { data } = await axios.get(url);
    return data
  }

  const getCustomersApiRequest = async () => {
    const url = `/api/customers`;
    const { data } = await axios.get(url);
    return data;
  }

  useEffect(() => {
    const abctrl = new AbortController();
    getCategories(abctrl)
      .then((res) => setEventTypesList(res))
      .catch((er) =>
        console.log("error")
      );
    return () => abctrl.abort();
  }, [setEventTypesList]);

  useEffect(() => {
    let oggi = dayjs(new Date());
    console.log("oggi = ", dayjs(new Date()));
    setBookingStartDateNameOfWeek(config.DAY_ITALIAN_NAMES[oggi.day()]);
    console.log("bookingStartDateNameOfWeek = ", config.DAY_ITALIAN_NAMES[oggi.day()]);

    setBookingStartDate(dayjs(oggi.format('YYYY-MM-DD')));
    console.log("bookingStartDate = ", dayjs(oggi.format('YYYY-MM-DD')));
    setBookingEndDate(dayjs(oggi.format('YYYY-MM-DD')));

    setIndexStartDateBooking(getIndexOfDaysDb(dayjs(oggi.format('YYYY-MM-DD'))));
    console.log("indexStartDateBooking = ", getIndexOfDaysDb(dayjs(oggi.format('YYYY-MM-DD'))));
    setIndexEndDateBooking(getIndexOfDaysDb(dayjs(oggi.format('YYYY-MM-DD'))));

    //setBookingStartDate(dayjs(event.format('YYYY-MM-DD')));
    //setBookingStartDateNameOfWeek(config.DAY_ITALIAN_NAMES[dayjs(event).day()]);
    //setBookingStartDate(dayjs('2026-03-01'));
    //setIndexStartDateBooking(getIndexOfDaysDb(dayjs('2026-03-01'), 0));
    //setBookingStartDateNameOfWeek(config.DAY_ITALIAN_NAMES[dayjs('2026-03-01').day()]);

    setDisplayPaperImages("none")
  }, [setBookingStartDate])

  useEffect(() => {
    getResourcesApiRequest().then((res) => setResources(res))
      .catch((er) => {
        console.log(er);
      });
  }, []);

  useEffect(() => {
    getSitesApiRequest().then((sit) => setSites(sit))
      .catch((er) => {
        console.log(er);
      });
  }, []);

  useEffect(() => {
    getCustomersApiRequest().then((cus) => {
      setCustomersList(cus);
      console.log('customersList data =', cus)
      console.log(`[useEffect] customersList = `, customersList);
    })
      .catch((er) => {
        console.log(er);
      });
  }, []);


  const handleChangeSito = (event) => {
    setSitoScelto(event.target.value);
  };

  const handleChangeRisorsa = (event) => {
    setRisorsaScelta(event.target.value);
  };

  const handleChangeCliente = (event) => {
    setClienteDigitato(event.target.value);
  };

  function getFieldsCustomer(input, field1, field2, field3) {
    var output = [];
    for (var i = 0; i < input.length; ++i)
      output.push(input[i][field1] + ' ' + input[i][field2] + ' ' + input[i][field3]);
    return output;
  }
  var optionCustomers = getFieldsCustomer(customersList, 'title', 'name', 'surname');

  const switchIsManyDays = (event) => {
    setIsManyDays(event.target.checked);
    console.log('[switch] isManyDays =', isManyDays)
  };

  // --- INI -------  Confirm Dialog

  const [idServiceInWorking, setIdServiceInWorking] = useState("");
  const [nameInWorking, setNameInWorking] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);
  const [openDialogDeleteAppointment, setOpenDialogDeleteAppointment] = React.useState(false);

  const handleClickOpenConfirmDeleteAppointment = () => {
    setOpenDialogDeleteAppointment(true);
  };

  const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
    console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =", progressivoRagSoc);
    const url = `/api/configs/progressivo/` + progressivoRagSoc;
    const { data } = await axios.get(url);
    return data
  }


  const deleteAppointmentApiRequest = async (indexDay, indexAppointment) => {
    console.log("[deleteAppointmentApiRequest]");
    console.log("[deleteAppointmentApiRequest] indexDay=", indexDay);
    console.log("[deleteAppointmentApiRequest] indexAppointment=", indexAppointment);

    console.log("[deleteAppointmentApiRequest] vedi eventi di indexStartDateBooking=", indexStartDateBooking);
    console.log("[handleSalvaAppuntamento] bookingStartDate =" + bookingStartDate.format('YYYY-MM-DD'));

    const infoAppointment = {
      //"indexDay": indexStartDateBooking,
      "indexDay": indexDay,
      "indexAppointment": indexAppointment,
    }

    console.log("[updateAppointmentApiRequest] infoAppointment=", infoAppointment)
    console.log("[updateAppointmentApiRequest] POST /api/appointments/delete")

    const { data } = await axios.post("/api/appointments/delete", infoAppointment);
    return data

  };

  const PopupConfirmConfirm = (indexDay, indexAppointment) => {
    console.log('[PopupConfirmConfirm]')

    console.log("[PopupConfirmConfirm] indexDay=", indexDay)
    console.log("[PopupConfirmConfirm] indexAppointment=", indexAppointment)
    console.log("[PopupConfirmConfirm] POST /api/appointments/delete?indexDay?indexAppointment")

    deleteAppointmentApiRequest(indexDay, indexAppointment).then((data) => {
      console.log(`data di deleteAppointmentApiRequest =`, data);
    })
      .catch((er) => {
        console.log(er);
      });

    console.log('[PopupConfirmClose]')
    setOpenDialogDeleteAppointment(false);

    // render page
    navigate(0);
  }

  const PopupConfirmClose = () => {
    console.log('[PopupConfirmClose]')
    setOpenDialogDeleteAppointment(false);
  };

  const ViewConfirmDialog = () => {
    return (
      <Dialog
        open={openDialogDeleteAppointment}
        onClose={PopupConfirmClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >

        <DialogTitle
          id="alert-dialog-title"
          style={{ background: "#4bf5cc", fontWeight: "bold" }}>
          Cancellazione evento
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description" >
            &nbsp;
          </DialogContentText>
          <DialogContentText id="alert-dialog-description" >
            Confermi la cancellazione evento di  <br />
            <b><i> {bookingStartDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingStartDate))} ore {hourStartBookingString} ? </i></b>  <br />
          </DialogContentText>
          <DialogContentText id="alert-dialog-description" >
            &nbsp;
          </DialogContentText>
        </DialogContent>

        <DialogActions
        >

          <Button
            variant="contained"
            size="small"
            color="warning"
            onClick={PopupConfirmClose}>
            <Typography
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                color: 'white',
                fontFamily: 'Arial',
                textTransform: 'none',
                fontSize: 16,
              }}
            >
              Annulla
            </Typography>
          </Button>

          <Button
            variant="contained"
            size="small"
            color="success"
            onClick={() => {
              PopupConfirmConfirm(indexStartDateBooking, showDetailAppointmentNumber)
            }}
            autoFocus
          >
            <Typography
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                color: 'white',
                fontFamily: 'Arial',
                textTransform: 'none',
                fontSize: 16,
              }}
            >
              Cancella
            </Typography>
          </Button>
        </DialogActions>

      </Dialog>
    );
  };
  // --- FIN -------  Confirm Dialog


  return (
    <>

      <Box sx={{ flexGrow: 1 }}>

        <AdminMenuComponent></AdminMenuComponent>

        <Grid container spacing={{ xs: 0, md: 2 }}>

          <Grid
            size={{ xs: 12, md: 10 }}
            paddingTop={{ xs: 0, md: 1 }}
            paddingLeft={1}
            paddingRight={3}
            spacing={0}
          >
            <Stack
              spacing={2}
              sx={{ flexDirection: { xs: "column", md: "column" }, paddingTop: { xs: 0, md: 0 }, paddingLeft: 1, paddingRight: 0, }}
            >

              <Typography
                sx={{
                  paddingTop: { xs: 2, md: 0 }, paddingBottom: 0, paddingLeft: { xs: 1, md: 0 }, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 30,
                  color: 'navy',
                }}
              >
                <b>{title}</b>
              </Typography>

              <Typography
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 300,
                  fontSize: 20,
                  color: 'navy',
                }}
              >
                <em>{subTitle}</em>
              </Typography>

              <Typography
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 100,
                  fontSize: 14,
                  color: 'black',
                }}
              >
                {description}
              </Typography>

            </Stack>

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 30
              }}
            />

            <Grid container
              spacing={2}
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              }}
            >

              <Grid size={{ xs: 1, md: 0.1 }}>
              </Grid>

              <Grid size={{ xs: 12, md: 3.4 }}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                }}
              >

                <Paper
                  sx={{
                    paddingTop: 1, paddingBottom: 2, paddingLeft: 1, paddingRight: 1,
                    background: '#cce0e6',
                    color: '#3b1e8d'
                  }}
                  elevation={6}
                >

                  <Typography
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      fontFamily: 'Arial',
                      fontWeight: 600,
                      fontSize: 20,
                      color: 'navy',
                      background: '#44cdc4',
                      textAlign: 'center',
                    }}
                  >
                    {bookingStartDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingStartDate))}
                  </Typography>


                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="it"
                  >
                    <DemoContainer components={['DateCalendar', 'DateCalendar']} color={'#3b1e8d'}>
                      <DemoItem color={'#3b1e8d'}>

                        <DateCalendar
                          value={bookingStartDate}

                          onChange={(newValue) => {
                            // nascondo creazione evento 
                            setShowDetailAppointmentNumber(-1);
                            setShowHourAppointmentSection("No");
                            // nascondo dettagli evento 
                            setShowInfoEventSection("No");

                            setBookingStartDate(newValue);
                            setBookingStartDateNameOfWeek(config.DAY_ITALIAN_NAMES[dayjs(newValue).day()]);
                            console.log('Date selected:', newValue);
                            console.log('Date selected:', newValue.format('YYYY-MM-DD'));
                            console.log('Date selected:', config.DAY_ITALIAN_NAMES[dayjs(newValue).day()]);

                            setIndexStartDateBooking(getIndexOfDaysDb(dayjs(newValue.format('YYYY-MM-DD'))));

                            console.log("indexStartDateBooking = ", getIndexOfDaysDb(dayjs(newValue.format('YYYY-MM-DD'))));
                            //setIndexEndDateBooking(getIndexOfDaysDb(dayjs(event.format('YYYY-MM-DD')), correctionIndexDay));

                            setAppointments(null);
                            setDailyAppointments(null);

                            // leggo db

                            getAppointmentsByDayApiRequest(getIndexOfDaysDb(dayjs(newValue.format('YYYY-MM-DD'))))
                              .then((data) => {
                                setAppointments(data?.appointments);
                                setDailyAppointments(data[0]?.appointments);
                                //setAppointments(data?.appointments);
                                console.log('[handleVediEventiGiorno] data=', data);
                                console.log('[handleVediEventiGiorno] data?.appointments=', data[0]?.appointments);
                                //console.log('appointment=', data?.appointment);
                                //console.log('appointments=', data?.appointments);
                                //setAppointment(data?.appointments[0]);
                                //console.log('appointment=', data?.appointment);

                              })
                              .catch((er) => {
                                console.log(er);
                              });

                            setShowDailyEventsSection("Si");
                          }}

                          sx={{
                            bgcolor: '#a9d1f7',
                            boxShadow: 1,
                            borderRadius: 2,
                            //p: 2,
                            minWidth: 300,
                          }}
                          minDate={dayjs('2026-01-01')}
                          maxDate={dayjs('2028-12-31')}
                        />
                      </DemoItem>
                    </DemoContainer>
                  </LocalizationProvider>

                </Paper>

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    height: 40
                  }}
                />

              </Grid>

              <Grid size={{ xs: 1, md: 0.1 }}>
              </Grid>

              {/* ---------------------------   INI inserimento ora inizio   --------------------------- */}
              {/* 

              <Grid size={{ xs: 12, md: 3.4 }}
                display={showHourAppointmentSection === 'Si' ? "block" : "none"}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                }}
              >

                <Paper
                  sx={{
                    paddingTop: 1, paddingBottom: 2, paddingLeft: 1, paddingRight: 1,
                    background: '#cce0e6',
                    color: 'navy',

                  }}
                  elevation={6}
                >

                  <Grid container alignItems="baseline" justifyContent="center"
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      display: 'flex',
                      background: '#3970c9',
                      flexDirection: { xs: "row", md: "row" },
                    }}
                  >
                    <Grid item>
                      <Typography
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          fontFamily: 'Arial',
                          fontWeight: 100,
                          fontSize: 14,
                          color: '#f7f4f4',
                        }}
                      >
                        crea evento
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          fontFamily: 'Roboto',
                          fontWeight: 300,
                          fontSize: 20,
                          color: '#f7f4f4',
                        }}
                      >
                        &nbsp;&nbsp; <b>{bookingStartDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingStartDate))}</b>
                      </Typography>
                    </Grid>
                  </Grid>

                  <Box display="flex" flexDirection="row">
                    <Typography
                      sx={{
                        paddingTop: 2, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        fontFamily: 'Arial',
                        fontWeight: 600,
                        fontSize: 16,
                        color: 'navy',
                        textAlign: 'left'
                      }}
                    >
                      &nbsp;ora di inizio evento
                    </Typography>
                    <Typography
                      sx={{
                        paddingTop: 1.3, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        fontFamily: 'Rpboto',
                        fontWeight: 600,
                        fontSize: 22,
                        color: 'black',
                        //background: 'green',
                        textAlign: 'center'
                      }}
                    >
                      &nbsp;&nbsp;{hourStartBookingString}
                    </Typography>
                  </Box>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['TimeClock', 'TimeClock']} color={'#3b1e8d'}>
                      <DemoItem label="">
                        <TimeClock
                          value={hourStartBooking}
                          sx={{
                            bgcolor: '#a9d1f7',
                            boxShadow: 1,
                            borderRadius: 2,
                            //p: 2,
                            //minWidth: 300,
                          }}
                          //onChange={(newValue) => setHourMinuteValue(newValue)}
                          onChange={
                            handleSelectionStartHourFromCalendar
                          }
                          ampm={false} />
                      </DemoItem>
                    </DemoContainer>
                  </LocalizationProvider>

                  <FormControlLabel
                    control={<Switch defaultChecked />}
                    checked={isManyDays}
                    onChange={switchIsManyDays}
                    label="più giorni"
                    sx={{
                      paddingTop: 1, paddingLeft: 1, paddingRight: 0,
                    }}
                    disabled
                  />

                  {isManyDays &&

                    <Stack
                      sx={{
                        flexDirection: { xs: "row", md: "row" },
                        paddingTop: 0, paddingLeft: 0, paddingRight: 0,
                      }}
                    >

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['TimeClock', 'TimeClock']} color={'#3b1e8d'}>

                          <Box display="flex" flexDirection="row">
                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                fontFamily: 'Arial',
                                fontWeight: 600,
                                fontSize: 16,
                                color: 'navy',
                                textAlign: 'left'
                              }}
                            >
                              &nbsp;giorno fine evento
                            </Typography>
                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                fontFamily: 'Arial',
                                fontWeight: 600,
                                fontSize: 16,
                                color: 'navy',
                                textAlign: 'left'
                              }}
                            >
                              &nbsp;{bookingEndDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingEndDate))}
                            </Typography>
                          </Box>

                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="it"
                          >
                            <DemoContainer components={['DateCalendar', 'DateCalendar']} color={'#3b1e8d'}>
                              <DemoItem label="" color={'#3b1e8d'}>
                                <DateCalendar
                                  value={bookingEndDate}
                                  onChange={selectionEndDateFromCalendar}
                                  sx={{
                                    bgcolor: '#a9d1f7',
                                    boxShadow: 1,
                                    borderRadius: 2,
                                    //p: 2,
                                    minWidth: 300,
                                  }}
                                  minDate={dayjs('2026-01-01')}
                                  maxDate={dayjs('2028-12-31')}
                                />
                              </DemoItem>
                            </DemoContainer>
                          </LocalizationProvider>

                          <Box display="flex" flexDirection="row">
                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                fontFamily: 'Arial',
                                fontWeight: 600,
                                fontSize: 16,
                                color: 'navy',
                                textAlign: 'center'
                              }}
                            >
                              &nbsp;ora di fine evento
                            </Typography>
                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                fontFamily: 'Rpboto',
                                fontWeight: 600,
                                fontSize: 22,
                                color: 'black',
                                //background: 'green',
                                textAlign: 'center'
                              }}
                            >
                              &nbsp;{hourEndBookingString}
                            </Typography>
                          </Box>

                          <DemoItem label="">
                            <TimeClock
                              value={hourEndBooking}
                              sx={{
                                bgcolor: '#a9d1f7',
                                boxShadow: 1,
                                borderRadius: 2,
                                //p: 2,
                                //minWidth: 300,
                              }}
                              //onChange={(newValue) => setHourMinuteValue(newValue)}
                              onChange={handleSelectionEndHourFromCalendar}
                              ampm={false} />
                          </DemoItem>

                        </DemoContainer>
                      </LocalizationProvider>

                    </Stack>
                  }

                  <Box
                    sx={{ '& > :not(style)': { m: 1, } }}
                  >

                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                      my={0}
                    >

                      <Button
                        type="button"
                        variant="contained"
                        color="warning"
                        //size="small"
                        onClick={(e) => {
                          //handleAnnullaFissaOraAppuntamento();
                          setShowHourAppointmentSection("No");
                          setShowInfoEventSection("No");
                          setHourStartBooking(null);   // reset  timeclock  
                          setHourStartBookingString("");
                        }}
                        sx={{
                          width: "18ch",
                          borderRadius: 2,
                          //backgroundColor: "#148840",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            Chiudi
                          </Typography>
                        </Stack>
                      </Button>

                    </Stack>

                  </Box>

                </Paper>

              </Grid>
            */}
              {/* ---------------------------   FIN inserimento ora inizio   --------------------------- */}



              {/* -----------------   INI visualizza tutti gli eventi del giorno  ----------------- */}

              <Grid size={{ xs: 12, md: 4.5 }}
                display={showDailyEventsSection === 'Si' ? "block" : "none"}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                }}
              >

                <Paper
                  sx={{
                    paddingTop: 1, paddingBottom: 1, paddingLeft: 1, paddingRight: 1,
                    background: '#cce0e6',
                    color: 'navy',

                  }}
                  elevation={6}
                >

                  <Grid alignItems="baseline" justifyContent="center" size={{ xs: 12, md: 12 }}
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      display: 'flex',
                      background: '#3970c9',
                      flexDirection: { xs: "row", md: "row" },
                    }}
                  >
                    <Grid item>
                      <Typography
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                          fontFamily: 'Arial',
                          fontWeight: 100,
                          fontSize: 14,
                          color: '#f7f4f4',
                        }}
                      >
                        elenco eventi
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          fontFamily: 'Roboto',
                          fontWeight: 300,
                          fontSize: 20,
                          color: '#f7f4f4',
                        }}
                      >
                        &nbsp;&nbsp; <b>{bookingStartDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingStartDate))}</b>
                      </Typography>
                    </Grid>

                    <Grid item
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        display: 'flex',
                        color: '#f7f4f4',
                        //background: '#f7f4f4',
                        justifyContent: "flex-end",
                        width: "10ch"

                      }}
                    >
                      <Tooltip title="crea evento" arrow placement="top">
                        <IconButton
                          size="small"
                          aria-label="account of current user"
                          aria-controls="menu-appbar"
                          aria-haspopup="true"
                          onClick={(e) => {
                            // azzero variabili da ins
                            setTitleAppointment("");
                            setDescriptionAppointment("");
                            setNoteAppointment("");
                            setProdottoScelto("");
                            setCategoriaScelta("");
                            setRisorsaScelta("");
                            setSitoScelto("");
                            setClienteDigitato("");
                            setHourStartBookingString("");
                            setDurataScelta("");
                            setCategory("");

                            setShowInfoEventSection("Si");

                            setShowDailyEventsSection("No");
                            setShowDetailAppointmentNumber(-1);
                            setShowHourAppointmentSection("Si");
                          }}
                          color="inherit"
                        >
                          &nbsp;&nbsp;<CreateNewFolderTwoToneIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>

                    <Grid item
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        display: 'flex',
                        color: '#f7f4f4',
                        //background: '#f7f4f4',
                        justifyContent: "flex-end",
                        //width: "13ch"

                      }}
                    >
                      <Tooltip title="chiudi" arrow placement="top">
                        <IconButton
                          size="small"
                          aria-label="account of current user"
                          aria-controls="menu-appbar"
                          aria-haspopup="true"
                          onClick={(e) => {
                            handleAnnullaEventiDelGiorno();
                          }}
                          color="inherit"
                        >
                          &nbsp;&nbsp;<CancelPresentationIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>

                  </Grid>

                  <Box display="flex" flexDirection="row"
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 0,
                      //width: widthCard,
                    }}
                  >

                    <Grid
                      container
                      size={{ xs: 12, md: 4 }}
                      //paddingTop={{ xs: 1, md: 2 }}
                      //paddingLeft={{ xs: 1, md: 1 }}
                      //paddingRight={{ xs: 1, md: 1 }}
                      spacing={{ xs: 1, md: 1 }}
                      sx={{
                        paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        //width: widthCard,
                      }}
                    >

                      {dailyAppointments && dailyAppointments.length > 0 &&


                        dailyAppointments.map((appointment, idx) => (

                          <AppointmentCardComponent appointmentItem={appointment} idx={idx} setShowDetailAppointmentNumber={setShowDetailAppointmentNumber} setShowInfoEventSection={setShowInfoEventSection} setShowDeleteEventSection={setShowDeleteEventSection}
                            setShowDisplayEventSection={setShowDisplayEventSection} setOpenDialogDeleteAppointment={setOpenDialogDeleteAppointment} dailyAppointments={dailyAppointments}
                            setHourStartBooking={setHourStartBooking} setHourStartBookingString={setHourStartBookingString} setHourEndBooking={setHourEndBooking} setHourEndBookingString={setHourEndBookingString} setDurataScelta={setDurataScelta} setCategory={setCategory} setEvent={setEvent} setProdottoScelto={setProdottoScelto} setTitleAppointment={setTitleAppointment}
                            setDescriptionAppointment={setDescriptionAppointment} setNoteAppointment={setNoteAppointment} setClienteDigitato={setClienteDigitato} setRisorsaScelta={setRisorsaScelta} setSitoScelto={setSitoScelto}
                            getEventsApiRequest={getEventsApiRequest} setEventsList={setEventsList} setShowDailyEventsSection={setShowDailyEventsSection} setImages={setImages}
                          />

                        )
                        )
                      }
                      {!dailyAppointments &&
                        <Typography
                          sx={{
                            paddingTop: 4, paddingBottom: 4, paddingLeft: 2, paddingRight: 0,
                            fontFamily: 'Arial',
                            fontWeight: 300,
                            fontSize: 16,
                            color: 'navy',
                          }}
                        >
                          <em>nessun evento</em>
                        </Typography>
                      }

                      <Box
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          height: 10
                        }}
                      />

                    </Grid>


                    {/* 
                    <Typography
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        fontFamily: 'Arial',
                        fontWeight: 600,
                        fontSize: 16,
                        color: 'black',
                        textAlign: 'left'
                      }}
                    >
                      &nbsp;{hourStartBookingString}
                    </Typography>
                    */}

                  </Box>

                  <Box
                    sx={{ '& > :not(style)': { m: 1, } }}
                  >

                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                      my={0}
                    >

                      <Button
                        type="button"
                        variant="contained"
                        color="warning"
                        //size="small"
                        //endIcon={<AssignmentReturnTwoToneIcon />}
                        onClick={(e) => {
                          handleAnnullaEventiDelGiorno();
                        }}
                        sx={{
                          width: "18ch",
                          borderRadius: 2,
                          //backgroundColor: "#148840",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            Chiudi
                          </Typography>
                        </Stack>
                      </Button>

                      <Button
                        type="button"
                        variant="contained"
                        color="success"
                        //size="small"
                        endIcon={<CreateNewFolderTwoToneIcon />}
                        onClick={(e) => {
                          // azzero variabili da ins
                          setTitleAppointment("");
                          setDescriptionAppointment("");
                          setNoteAppointment("");
                          setProdottoScelto("");
                          setCategoriaScelta("");
                          setRisorsaScelta("");
                          setSitoScelto("");
                          setClienteDigitato("");
                          setHourStartBookingString("");
                          setDurataScelta("");
                          setCategory("");

                          setShowInfoEventSection("Si");

                          setShowDailyEventsSection("No");
                          setShowDetailAppointmentNumber(-1);
                          setShowHourAppointmentSection("Si");
                        }}

                        sx={{
                          width: "18ch",
                          borderRadius: 2,
                          backgroundColor: "#148840",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            Crea evento
                          </Typography>
                        </Stack>
                      </Button>

                    </Stack>

                  </Box>

                </Paper>

              </Grid>

              {/* -----------------   FIN visualizza tutti gli eventi del giorno  ----------------- */}

              <Grid size={{ xs: 1, md: 0.1 }}>
              </Grid>

              {/* ---------------------------   INI showInfoEventSection INSERIMENTO info e UPDATE  --------------------------- */}

              <Grid size={{ xs: 12, md: 4.5 }}
                display={showInfoEventSection === 'Si' ? "block" : "none"}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                }}
              >

                <Paper
                  sx={{
                    paddingTop: 1, paddingBottom: 2, paddingLeft: 1, paddingRight: 1,
                    background: '#cce0e6',
                    color: 'navy',
                  }}
                  elevation={6}
                >

                  <Grid container alignItems="baseline" justifyContent="center" size={{ xs: 12, md: 12 }} spacing={1}
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      display: 'flex',
                      background: '#3970c9',
                      flexDirection: { xs: "row", md: "row" },
                    }}
                  >
                    <Grid item>
                      <Typography
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          fontFamily: 'Arial',
                          fontWeight: 100,
                          fontSize: { xs: 12, md: 14 },
                          color: '#f7f4f4',
                        }}
                      >
                        {showDetailAppointmentNumber == -1 ? "crea" : "modifica"} evento
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          fontFamily: 'Roboto',
                          fontWeight: 300,
                          fontSize: { xs: 16, md: 20 },
                          color: '#f7f4f4',
                        }}
                      >
                        <b>{bookingStartDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingStartDate))}</b>
                      </Typography>
                    </Grid>
                    <Grid item
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        display: 'flex',
                        color: '#f7f4f4',
                        //background: '#f7f4f4',
                        justifyContent: "flex-end",
                        //width: "13ch"
                        //minWidth: 50,
                      }}
                    >
                      <Tooltip title="salva" arrow placement="top">
                        <IconButton
                          size="small"
                          aria-label="account of current user"
                          aria-controls="menu-appbar"
                          aria-haspopup="true"
                          onClick={(e) => {
                            handleSalvaAppuntamento();

                            // leggo db
                            getAppointmentsByDayApiRequest(getIndexOfDaysDb(dayjs(bookingStartDate.format('YYYY-MM-DD'))))
                              .then((data) => {
                                setAppointments(data?.appointments);
                                setDailyAppointments(data[0]?.appointments);
                                //setAppointments(data?.appointments);
                                console.log('[handleVediEventiGiorno] data=', data);
                                console.log('[handleVediEventiGiorno] data?.appointments=', data[0]?.appointments);
                                //console.log('appointment=', data?.appointment);
                                //console.log('appointments=', data?.appointments);
                                //setAppointment(data?.appointments[0]);
                                //console.log('appointment=', data?.appointment);

                              })
                              .catch((er) => {
                                console.log(er);
                              });

                            setShowDailyEventsSection("Si");

                            // azzero variabili da ins
                            setTitleAppointment("");
                            setDescriptionAppointment("");
                            setNoteAppointment("");
                            setProdottoScelto("");
                            setCategoriaScelta("");
                            setRisorsaScelta("");
                            setSitoScelto("");
                            setClienteDigitato("");
                            setHourStartBookingString("");
                            setDurataScelta("");
                            setCategory("");

                            setShowInfoEventSection("Si");

                            setShowDailyEventsSection("No");
                            setShowDetailAppointmentNumber(-1);
                            setShowHourAppointmentSection("Si");
                          }}
                          color="inherit"
                        >
                          &nbsp;&nbsp;<SaveAltSharpIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>

                    <Grid item
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        display: 'flex',
                        color: '#f7f4f4',
                        //background: '#f7f4f4',
                        justifyContent: "flex-end",
                        //width: "10ch"
                      }}
                    >
                      <Tooltip title="annulla" arrow placement="top">
                        <IconButton
                          size="small"
                          aria-label="account of current user"
                          aria-controls="menu-appbar"
                          aria-haspopup="true"
                          onClick={(e) => {
                            handleAnnullaInserisciInfo();
                          }}
                          color="inherit"
                        >
                          &nbsp;<CancelPresentationIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>

                  </Grid>

                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                      paddingTop: 2, paddingBottom: 1, paddingLeft: 1, paddingRight: 1,
                    }}
                  >

                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="it"
                      localeText={itIT.components.MuiLocalizationProvider.defaultProps.localeText}
                    >

                      <DemoContainer
                        components={[
                          'TimePicker',
                          'MobileTimePicker',
                          'DesktopTimePicker',
                          'StaticTimePicker',
                        ]}
                      >
                        <DemoItem ampm={false}>
                          <MobileTimePicker
                            //defaultValue={hourStartBooking}
                            value={dayjs().hour(Number(hourStartBookingString.substring(0, 2))).minute(Number(hourStartBookingString.substring(3, 5)))}
                            onChange={(newValue) => {
                              handleSelectionStartHourFromCalendar(newValue);
                            }}
                            label="ora inizio"
                            //ampm={false}
                            sx={{
                              //width: "17ch",
                              minWidth: "9ch",
                              p: { xs: 0, md: 0 },
                              m: { xs: 0, md: 0 },
                            }}
                          />
                        </DemoItem>
                      </DemoContainer>

                    </LocalizationProvider>

                    {/* 

                    {!isManyDays &&

                      <Box
                        style={{
                          //width: "25ch",
                          paddingTop: 8,
                        }}
                      >

                        <FormControl
                          required
                          style={{
                            //width: "21ch",
                            paddingLeft: 0,
                          }}
                        >
                          <InputLabel id="sel-durata">durata</InputLabel>
                          <Select
                            labelId="sel-durata"
                            id="id-sel-durata"
                            value={durataScelta}
                            label="Durata"
                            //onChange={handleChangeDurata}
                          onChange={(e) => {
                            handleChangeDurata(e);
                          }}


                            sx={{
                              minWidth: "20ch"
                              //width: "18ch",
                            }}
                          >
                            {durationsMins.map(duration => {
                              return (
                                <MenuItem key={duration.message} value={duration.valueMins}>
                                  {duration.message}
                                </MenuItem>
                              )
                            })}
                          </Select>
                        </FormControl>
                      </Box>
                    }
            */}

                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="it"
                      localeText={itIT.components.MuiLocalizationProvider.defaultProps.localeText}
                    >
                      <DemoContainer
                        components={[
                          'TimePicker',
                          'MobileTimePicker',
                          'DesktopTimePicker',
                          'StaticTimePicker',
                        ]}
                      >
                        <DemoItem ampm={false}>
                          <MobileTimePicker
                            //defaultValue={hourEndBooking}
                            value={dayjs().hour(Number(hourEndBookingString.substring(0, 2))).minute(Number(hourEndBookingString.substring(3, 5)))}
                            onChange={(newValue) => {
                              handleSelectionEndHourFromCalendar(newValue);
                            }}
                            label="ora fine"
                            //ampm={false}
                            sx={{
                              //width: "17ch",
                              minWidth: "9ch",
                              p: { xs: 0, md: 0 },
                              m: { xs: 0, md: 0 },
                            }}
                          />
                        </DemoItem>
                      </DemoContainer>

                    </LocalizationProvider>

                  </Stack>

                  <Stack
                    direction="column"
                    spacing={1}
                    sx={{
                      paddingTop: 0, paddingBottom: 2, paddingLeft: 1, paddingRight: 1,
                    }}
                  >

                    <FormControl
                      sx={{
                        //width: "50ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 1 },
                      }}
                    >
                      <InputLabel id="style-select-label">
                        tipo evento
                      </InputLabel >
                      <Select
                        labelId="style-select-label"
                        id="style-select-label"
                        value={category}
                        label="tipo evento"
                        onChange={handleSelectEventType}
                      >

                        {eventTypesList.map((categoryItem, idx) => (
                          <MenuItem value={categoryItem.name}>{categoryItem.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl
                      sx={{
                        //width: "50ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 1 },
                      }}
                    >
                      <InputLabel
                        id="style-select-label-evento"
                      >
                        evento
                      </InputLabel >
                      <Select
                        labelId="style-select-label-evento"
                        id="style-select-label-evento"
                        value={prodottoScelto}
                        //defaultValue={prodottoScelto}
                        label="evento"
                        onChange={handleSelectEvent}
                      >

                        {eventsList.map((eventItem, idx) => (
                          <MenuItem value={eventItem.name}>{eventItem.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField id="id-title"
                      label="titolo"
                      variant="outlined"
                      value={titleAppointment}
                      sx={{
                        //width: "50ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 1 },
                      }}
                      onChange={(event) => {
                        setTitleAppointment(event.target.value);
                      }}
                    />

                    <TextField id="id-descriptionApp"
                      label="Descrizione"
                      variant="outlined"
                      value={descriptionAppointment}
                      sx={{
                        //width: "50ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 1 },
                      }}
                      onChange={(event) => {
                        setDescriptionAppointment(event.target.value);
                      }}
                    />

                    <TextField id="id-note"
                      label="Note"
                      variant="outlined"
                      value={noteAppointment}
                      sx={{
                        //width: "50ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 1 },
                      }}
                      onChange={(event) => {
                        setNoteAppointment(event.target.value);
                      }}
                      multiline
                      rows={3}
                      maxRows={6}
                    />

                    <Autocomplete
                      disablePortal
                      options={optionCustomers}
                      renderInput={(params) => <TextField {...params} label="Cliente" />}
                      onChange={(event, value) => {
                        setClienteDigitato(value);
                      }}
                      defaultValue={cliente}
                      value={clienteDigitato}
                    />

                    <Stack
                      direction="row"
                      //alignItems="center"
                      spacing={2}
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      }}
                    >

                      <FormControl
                        style={{
                          minWidth: "20ch",
                        }}
                      >
                        <InputLabel id="sel-risorsa">Risorsa</InputLabel>
                        <Select
                          labelId="sel-risorsa"
                          id="id-sel-risorsa"
                          value={risorsaScelta}
                          label="Risorsa"
                          onChange={handleChangeRisorsa}
                          defaultValue={risorsa}
                        >
                          {resources.map(resource => {
                            return (
                              <MenuItem key={resource.name} value={resource.name}>
                                {resource.name}
                              </MenuItem>
                            )
                          })}
                        </Select>
                      </FormControl>

                      <FormControl
                        style={{
                          minWidth: "20ch",
                        }}
                      >
                        <InputLabel id="sel-sito">Luogo</InputLabel>
                        <Select
                          labelId="sel-sito"
                          id="id-sel-sito"
                          value={sitoScelto}
                          label="Luogo"
                          onChange={handleChangeSito}
                          defaultValue={sito}
                        >
                          {sites.map(site => {
                            return (
                              <MenuItem key={site.name} value={site.name}>
                                {site.name}
                              </MenuItem>
                            )
                          })}
                        </Select>
                      </FormControl>
                    </Stack>

                  </Stack>


                  <Paper
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      //background: '#cce0e6',
                      //background: '#8fe2ee',
                      background: '#8fe2ee',
                      //display: "none"
                      //display: "block"               
                      //display: displayPaperImages
                    }}
                  >

                    <Box
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      }}
                    >

                      <Stack
                        sx={{
                          paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          display: 'flex',
                          flexDirection: { xs: "row", md: "row" },
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >

                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          size="small"
                          component="label"
                          fullWidth
                          endIcon={<AddPhotoAlternateTwoToneIcon />}
                          sx={{
                            width: "16ch",
                            p: 1,
                            m: 1,
                          }}
                        >

                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={0}
                            my={0}                  >

                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                color: 'white',
                                fontFamily: 'Arial',
                                textTransform: 'none',
                                fontSize: 14,
                              }}
                            >
                              carica img
                            </Typography>
                          </Stack>
                          <input type="file" onChange={handleLoadImage} hidden accept=".jpg" />
                        </Button>

                        <Typography
                          sx={{
                            width: "20ch",
                            color: "#4433d8",
                            fontFamily: 'Arial',
                            fontWeight: 300,
                            fontSize: 12,
                            p: 1,
                            m: 1,
                            paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                          }}
                        >
                          {images.length} immagini caricate
                        </Typography>

                      </Stack>

                      <Stack
                        sx={{
                          flexDirection: { xs: "row", md: "row" },
                          paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 1,
                          position: "center", overflowX: "scroll",
                          '@media (min-width: 600px)': { width: '437px' },
                          '!@media (min-width: 600px)': { width: '500px' },
                        }}
                      >

                        {images.map((image, idx) => (

                          <CreateAppointmentElementCard key={idx} imagePath={image.path} idx={idx} pageId={id} nameImage={image.name} titleImage={image.title} subTitleImage={image.subTitle} pageAll={event} indexDay={indexStartDateBooking}/>

                        ))}

                      </Stack>

                    </Box>

                  </Paper>




                  <Box
                    sx={{ '& > :not(style)': { m: 1, } }}
                  >

                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                      sx={{
                        paddingTop: 2, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      }}
                    >

                      <Button
                        type="button"
                        variant="contained"
                        color="warning"
                        //size="small"
                        onClick={(e) => {
                          handleAnnullaInserisciInfo();
                        }}
                        sx={{
                          width: "18ch",
                          borderRadius: 2,
                          //backgroundColor: "#8e9112",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            Chiudi
                          </Typography>
                        </Stack>
                      </Button>

                      <Button
                        type="button"
                        variant="contained"
                        endIcon={<InventoryTwoToneIcon />}
                        color="success"
                        //size="small"
                        onClick={(e) => {
                          handleSalvaAppuntamento();

                          // leggo db
                          getAppointmentsByDayApiRequest(getIndexOfDaysDb(dayjs(bookingStartDate.format('YYYY-MM-DD'))))
                            .then((data) => {
                              setAppointments(data?.appointments);
                              setDailyAppointments(data[0]?.appointments);
                              //setAppointments(data?.appointments);
                              console.log('[handleVediEventiGiorno] data=', data);
                              console.log('[handleVediEventiGiorno] data?.appointments=', data[0]?.appointments);
                              //console.log('appointment=', data?.appointment);
                              //console.log('appointments=', data?.appointments);
                              //setAppointment(data?.appointments[0]);
                              //console.log('appointment=', data?.appointment);

                            })
                            .catch((er) => {
                              console.log(er);
                            });

                          setShowDailyEventsSection("Si");
                        }}
                        sx={{
                          width: "18ch",
                          borderRadius: 2,
                          backgroundColor: "#148840",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            Salva
                          </Typography>
                        </Stack>
                      </Button>

                    </Stack>

                  </Box>

                </Paper>

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    height: 40
                  }}
                />

              </Grid>

              {/* ---------------------------   FIN showInfoEventSection INSERIMENTO info e UPDATE  --------------------------- */}


              {/* ---------------------------   INI showDisplayEventSection VISUALIZZA info         --------------------------- */}

              <Grid size={{ xs: 12, md: 4.5 }}
                display={showDisplayEventSection === 'Si' ? "block" : "none"}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                }}
              >

                <Paper
                  sx={{
                    paddingTop: 1, paddingBottom: 2, paddingLeft: 1, paddingRight: 1,
                    background: '#cce0e6',
                    color: 'navy',
                  }}
                  elevation={6}
                >

                  <Grid container alignItems="baseline" justifyContent="center" size={{ xs: 12, md: 12 }} spacing={1}
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      display: 'flex',
                      background: '#3970c9',
                      flexDirection: { xs: "row", md: "row" },
                    }}
                  >
                    <Grid item>
                      <Typography
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          fontFamily: 'Arial',
                          fontWeight: 100,
                          fontSize: { xs: 12, md: 14 },
                          color: '#f7f4f4',
                        }}
                      >
                        vedi evento di
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                          fontFamily: 'Roboto',
                          fontWeight: 300,
                          fontSize: { xs: 16, md: 20 },
                          color: '#f7f4f4',
                        }}
                      >
                        <b>{bookingStartDateNameOfWeek} {strDateITAfromStrUSA(dayjs(bookingStartDate))}</b>
                      </Typography>
                    </Grid>
                    <Grid item
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        display: 'flex',
                        color: '#f7f4f4',
                        //background: '#f7f4f4',
                        justifyContent: "flex-end",
                        //width: "13ch"
                        minWidth: 120,
                      }}
                    >
                      <Tooltip title="chiudi" arrow placement="top">
                        <IconButton
                          size="small"
                          aria-label="account of current user"
                          aria-controls="menu-appbar"
                          aria-haspopup="true"
                          onClick={(e) => {
                            handleAnnullaInserisciInfo();
                          }}
                          color="inherit"
                        >
                          &nbsp;&nbsp;<CancelPresentationIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>

                  </Grid>

                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                      paddingTop: 2, paddingBottom: 1, paddingLeft: 1, paddingRight: 1,
                    }}
                  >

                    <TextField id="id-oraini" label="ora inizio" variant="outlined" value={hourStartBookingString} defaultValue={hourStartBookingString}
                      size="small"
                      sx={{
                        minWidth: "10ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 0, md: 0 },
                      }}
                      onChange={(event) => {
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                    />

                    {/* 
                    {!isManyDays &&

                      <TextField id="id-durata"
                        size="small"
                        label="durata (minuti)"
                        variant="outlined"
                        value={durataScelta}
                        sx={{
                          //minWidth: "28ch",
                          p: { xs: 0, md: 0 },
                          m: { xs: 1, md: 1 },
                        }}
                        onChange={(event) => {
                          setDurataScelta(event.target.value);
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    }
            */}

                    <TextField id="id-oraini" label="ora fine" variant="outlined" value={hourEndBookingString} defaultValue={hourEndBookingString}
                      size="small"
                      sx={{
                        minWidth: "10ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 0 },
                      }}
                      onChange={(event) => {
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                    />

                  </Stack>

                  <Stack
                    direction="column"
                    spacing={1}
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                    }}
                  >

                    <TextField id="id-category"
                      //size="small"
                      label="tipo evento"
                      variant="outlined"
                      value={category}
                      sx={{
                        //width: "50ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 1 },
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                    />

                    <TextField id="id-evento"
                      label="evento"
                      variant="outlined"
                      value={prodottoScelto}
                      sx={{
                        //width: "50ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 1 },
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                    />

                    <TextField id="id-title"
                      //size="small"
                      label="Titolo"
                      variant="outlined"
                      value={titleAppointment}
                      sx={{
                        //width: "50ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 1 },
                      }}
                      onChange={(event) => {
                        setTitleAppointment(event.target.value);
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                    />

                    <TextField id="id-descriptionApp"
                      //size="small"
                      label="descrizione"
                      variant="outlined"
                      value={descriptionAppointment}
                      sx={{
                        //width: "50ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 1 },
                      }}
                      onChange={(event) => {
                        setDescriptionAppointment(event.target.value);
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                    />

                    <TextField id="id-note"
                      //size="small"
                      label="note"
                      variant="outlined"
                      value={noteAppointment}
                      sx={{
                        //width: "50ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 1 },
                      }}
                      onChange={(event) => {
                        setNoteAppointment(event.target.value);
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      multiline
                      rows={3}
                      maxRows={6}
                    />

                    <TextField id="id-cliente"
                      //size="small"
                      label="cliente"
                      variant="outlined"
                      value={clienteDigitato}
                      sx={{
                        //width: "50ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 1 },
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                    />

                  </Stack>

                  <Stack
                    direction="row"
                    //alignItems="center"
                    spacing={2}
                    sx={{
                      paddingTop: 1, paddingBottom: 1, paddingLeft: 1, paddingRight: 1,
                    }}
                  >

                    <TextField id="id-rirsora"
                      //size="small"
                      label="risorsa"
                      variant="outlined"
                      value={risorsaScelta}
                      sx={{
                        //width: "24ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 1 },
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                    />

                    <TextField id="id-sito"
                      //size="small"
                      label="luogo"
                      variant="outlined"
                      value={sitoScelto}
                      sx={{
                        //width: "24ch",
                        p: { xs: 0, md: 0 },
                        m: { xs: 1, md: 1 },
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Stack>


                  <Box
                    sx={{ '& > :not(style)': { m: 1, } }}
                  >

                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      //alignItems="center"
                      spacing={2}
                    >

                      <Button
                        type="button"
                        variant="contained"
                        color="warning"
                        //size="small"
                        onClick={(e) => {
                          handleAnnullaInserisciInfo();
                        }}
                        sx={{
                          width: "18ch",
                          borderRadius: 2,
                          //backgroundColor: "#8e9112",
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={0}
                          my={0}
                        >
                          <Typography
                            sx={{
                              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                              color: 'white',
                              fontFamily: 'Roboto',
                              textTransform: 'none',
                              fontSize: 16,
                            }}
                          >
                            Chiudi
                          </Typography>
                        </Stack>
                      </Button>

                    </Stack>

                  </Box>

                </Paper>

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    height: 40
                  }}
                />

              </Grid>

              {/* ---------------------------   FIN showDisplayEventSection VISUALIZZA info         --------------------------- */}

            </Grid>

            < ViewConfirmDialog />

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 40
              }}
            />

          </Grid>
        </Grid>

      </Box >

    </>

  );
};

export default AppointmentPageComponent;
